import React from 'react'
import PropTypes from 'prop-types'
import styles from './Style.css'

const CenterSpinner = ({size}) => {
	return (
		<div className={styles.component}>
			<div className={styles.innerFlex}>
				<div className="glyphicon glyphicon-cog spinner" style={{fontSize: size}}></div>
			</div>
		</div>
	)
}

CenterSpinner.propTypes = {
	size: PropTypes.string
}

CenterSpinner.defaultProps = {
	size: '20px'
}

export default CenterSpinner



// WEBPACK FOOTER //
// ./client/components/layout/CenterSpinner/index.js